import { useMutation, useQueryClient } from 'react-query';
import Modal from '../../../../../commons/Modal/Modal';
import Button from '../../../../../designSystem/Button/Button';
import { BaseResponse } from '../../../../../../types/api/api.types';
import { DELETE_ACCOUNT_QUERY_KEY, deleteAccountQuery } from './DeleteAccountModal.query';
import { ButtonColor } from '../../../../../designSystem/Button/Button.types';
import { ModalProps } from '../../../../../commons/Modal/Modal.types';
import { signOut } from '../../../../../../store/authentication/authenticationActions/authenticationActions';
import { useDispatch } from 'react-redux';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { UserRoles } from '../../../../../../types/models/user/user.types';
import { useNavigate } from 'react-router-dom';

export default (props: ModalProps) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const currentUser = useCurrentUser();

  const { mutate } = useMutation<Awaited<BaseResponse>, Error>(() => deleteAccountQuery(), {
    mutationKey: DELETE_ACCOUNT_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      signOut(queryClient)(dispatch);
      navigate('/');
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  return (
    <Modal style={{ height: 'fit-content' }} closeOnClickOutside {...props}>
      <p>Êtes-vous sûr de vouloir supprimer votre compte ?</p>
      <p>
        Cette action est <strong>irréversible</strong>.
      </p>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        color={
          currentUser?.role === UserRoles.Entreprise ? ButtonColor.Secondary : ButtonColor.Primary
        }
        onClick={() => mutate()}>
        Oui
      </Button>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        color={
          currentUser?.role === UserRoles.Entreprise ? ButtonColor.Secondary : ButtonColor.Primary
        }
        onClick={() => props.setOpen(false)}>
        Non
      </Button>
    </Modal>
  );
};
